"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLang = exports.LangChoice = exports.LangChoiceInput = exports.langOptionStyles = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.langOptionStyles = {
    active: (0, app_1.css) `
    font-weight: bold;
  `,
};
exports.LangChoiceInput = (0, app_1.styled)(ui_1.ChoiceInput) `
  ${(theme) => theme.flexCenter};
  gap: unset;
  > [aria-checked] {
    font-weight: bold;
  }
`;
exports.LangChoice = (0, app_1.styled)(ui_1.ChoiceInput.Option) `
  border: unset;
  padding: unset;
  ${(_theme, props) => props.$active && exports.langOptionStyles.active};
`;
function ChangeLang({ currentLang = 'default', onClick, defaultLang, otherLang, className, }) {
    return ((0, jsx_runtime_1.jsxs)(exports.LangChoiceInput, Object.assign({ name: "chooseLang", onChange: (v) => {
            onClick();
            return v;
        }, className: className, defaultValue: currentLang, standalone: true }, { children: [(0, jsx_runtime_1.jsx)(exports.LangChoice, Object.assign({ value: "default" }, { children: defaultLang })), "/", (0, jsx_runtime_1.jsx)(exports.LangChoice, Object.assign({ value: "other" }, { children: otherLang }))] })));
}
exports.ChangeLang = ChangeLang;
